import React from 'react';

import PropTypes from 'prop-types';

import A from 'wanderu-component-react-router-link';
import { localize } from 'wanderu-i18n';

import baseAppConfig from 'wanderu-shellapp/src/config/baseApp.locales';

import styles from './TripOptions.scss';

const propTypes = {
    className: PropTypes.string,
    linkKey: PropTypes.string,
    locale: PropTypes.string,
    native: PropTypes.bool,
    onClick: PropTypes.func,
    optionClassName: PropTypes.string,
    options: PropTypes.arrayOf(PropTypes.object).isRequired,
    t: PropTypes.func.isRequired,
};

function TripOptions(props) {
    const {
        className = '',
        linkKey,
        locale = '',
        native = false,
        onClick = () => undefined,
        optionClassName = '',
        options = [],
        t,
    } = props;

    return (
        <ul className={`${styles.options} ${className}`}>
            {options.map((c2cObj) => (
                <li key={c2cObj.url}>
                    <A
                        className={`${styles.option} ${optionClassName}`}
                        href={c2cObj.url}
                        locale={locale}
                        native={native}
                        onClick={onClick}
                        underline="none"
                    >
                        {c2cObj.departCity && c2cObj.arriveCity
                            ? t(linkKey, {
                                replace1: c2cObj.departCity,
                                replace2: c2cObj.arriveCity,
                            })
                            : c2cObj.carrierName}
                    </A>
                </li>
            ))}
        </ul>
    );
}

TripOptions.propTypes = propTypes;

export { TripOptions };
export default localize(TripOptions, ['t'], baseAppConfig.namespace);
